import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  CircularProgress,
  Typography,
  useBreakpoints,
  useTheme,
} from '@monorepo/nova-ui';

export const NotificationsLoading: FC = () => {
  const { t } = useTranslation(['common']);
  const { isMobile } = useBreakpoints();
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height={isMobile ? '100%' : '192px'}
      padding="16px"
      borderRadius="16px"
      sx={{ backgroundColor: palette.background.paper }}
    >
      <Box marginBottom="16px">
        <CircularProgress size="60px" />
      </Box>
      <Typography fontSize={14} fontWeight={500}>
        {t('common:loading')}
      </Typography>
    </Box>
  );
};
